import PropTypes from 'prop-types'
import { useRef, useState } from 'react'
import { I18n, Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { MAIN_SCREEN } from '../../../constant'
import { TitlePanelSetting } from '../TitlePanelSetting'
import classes from '../index.module.scss'

const MAX_LENGTH = 125

const NamePanel = ({ panel, setValue }) => {
  const title = panel?.title || ''

  const inputRef = useRef()
  const isEditting = useRef()

  const [isEdit, setIsEdit] = useState(false)

  const enableEdit = () => {
    setIsEdit(true)
    setTimeout(() => {
      inputRef.current?.focus()
    }, 200)
  }

  const disableEdit = () => {
    setIsEdit(false)
    isEditting.current = false
  }

  const onChangeName = (e) => {
    if (e.target.value.length <= MAX_LENGTH) {
      setValue('title', e.target.value)
      isEditting.current = true
    }
  }

  return (
    <Element className={classes.namePanel} style={{ background: '#F3F3F3' }}>
      <Translate value="dynamicReport.PANEL_NAME" />{' '}
      {!isEdit ? (
        <>
          {title || (
            <>
              <TitlePanelSetting label={panel.label} />
              {panel.mainScreen && (
                <span>
                  {' '}
                  {panel.mainScreen === MAIN_SCREEN.COMPANY_ANALYSIS
                    ? '(C)'
                    : '(P)'}
                </span>
              )}
            </>
          )}
        </>
      ) : (
        <Element
          ref={inputRef}
          elementName="input"
          className={classes.inputPanelName}
          style={{ border: '1px solid #E0E0E0', color: '#3A414B' }}
          onBlur={disableEdit}
          onChange={onChangeName}
          value={
            isEditting.current
              ? title
              : title ||
                I18n.t(
                  typeof panel.label === 'string'
                    ? panel.label
                    : panel.label?.text,
                )
          }
        />
      )}
      <Icon
        onClick={enableEdit}
        style={{ color: '#9C9C9C', fontSize: 11 }}
        className="icon-edit-outline pl1"
      />
    </Element>
  )
}

NamePanel.propTypes = {
  panel: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
}

export default NamePanel
